<template>
  <b-container fluid>
    <b-spinner class="ml-3 absolute_center" v-if="isLoading"></b-spinner>

    <b-row>
      <b-col lg="6" class="my-1">
        <b-form-group
          label="Filter"
          label-for="filter-input"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              placeholder="Type to Search"
            ></b-form-input>

            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <ImportReportJsonComponent @getAllReports="getAllReports" />
    <b-table
      striped
      hover
      responsive
      :sticky-header="isStickyHeader"
      :filter="filter"
      :items="reports"
      :fields="fields"
    >
      <template #cell(Téléchargement)="row">
        <b-button
          @click="downloadReportsByUuid(row.item, 'static', '.pdf')"
          class="mb-1 pr-3 pl-3"
          variant="info"
        >
          Statique PDF
        </b-button>
        <b-button
          @click="downloadReportsByUuid(row.item, 'static', '.docx')"
          class="mb-1 pr-3 pl-3"
          variant="info"
        >
          Statique DOCX
        </b-button>
        <b-button
          @click="downloadReportsByUuid(row.item, 'dynamic', '.pdf')"
          class="mb-1 pr-3 pl-3"
          variant="warning"
        >
          Dynamic PDF</b-button
        >
        <b-button
          @click="downloadReportsByUuid(row.item, 'dynamic', '.docx')"
          class="mb-1 pr-3 pl-3"
          variant="warning"
        >
          Dynamic DOCX</b-button
        ><br />
        <b-button
          @click="downloadJsonReportsByUuid(row.item)"
          class="mb-1 pr-3 pl-3"
          variant="secondary"
        >
          Json
        </b-button>
      </template>
      <template #cell(Partager)="row">
        <b-button
          @click="showModal(row.item)"
          class="mb-1 pr-3 pl-3"
          variant="info"
        >
          Partager avec
        </b-button>
      </template>
      <template #cell(Supprimer)="row">
        <b-button
          @click="confirmBeforeDelete(row.item)"
          class="mb-1 pr-3 pl-3"
          variant="danger"
        >
          Supprimer
        </b-button>
      </template>
    </b-table>
    <div>
      <b-modal ref="shareModal" title="BootstrapVue" hide-footer>
        <p class="my-4">Partager avec</p>
        <b-form-input
          v-model="toShare.shareToMail"
          placeholder="Mail"
        ></b-form-input>
        <b-button
          variant="success"
          @click="shareReportWithUserId"
          class="mt-5 text-align-center"
          >Partager</b-button
        >
        <h4>{{ message }}</h4>
      </b-modal>
    </div>
  </b-container>
</template>

<script>
import ImportReportJsonComponent from "./ImportReportJsonComponent";

export default {
  name: "ReportsComponent",
  props: {},
  data() {
    return {
      toShare: {
        originUserId: 0,
        shareToMail: "",
        reportUuid: "",
      },
      isLoading: false,
      reports: [],
      fields: [
        {
          key: "userId",
          sortable: true,
        },
        {
          key: "email",
          sortable: true,
        },
        {
          key: "name",
          label: "Nom",
          sortable: true,
        },
        {
          key: "postalCode",
          label: "Code postal",
          sortable: true,
        },
        {
          key: "town",
          label: "Ville",
          sortable: true,
        },
        {
          key: "uuid",
          label: "Rapport uuid",
          sortable: true,
        },
        {
          key: "created_at",
          label: "Créé le",
          sortable: true,
          formatter: (value) => {
            const dateTime = new Date(value);
            return (
              dateTime.toLocaleDateString("fr-FR") +
              "\n" +
              dateTime.toLocaleTimeString("fr-FR")
            );
          },
        },
        {
          key: "updated_at",
          label: "Mis à jour le",
          sortable: true,
          formatter: (value) => {
            const dateTime = new Date(value);
            return (
              dateTime.toLocaleDateString("fr-FR") +
              "\n" +
              dateTime.toLocaleTimeString("fr-FR")
            );
          },
        },
        {
          key: "isDeleted",
          label: "Est supprimé",
          sortable: true,
        },
        {
          key: "isArchived",
          label: "Est archivé",
          sortable: true,
        },
        {
          key: "Téléchargement",
          sortable: false,
        },
        {
          key: "Partager",
          sortable: false,
        },
        {
          key: "Supprimer",
          sortable: false,
        },
      ],
      filter: "",
      isStickyHeader: window.innerHeight - 140 + "px",
      message: "",
    };
  },
  components: {
    ImportReportJsonComponent,
  },
  mounted() {
    this.getAllReports();
  },
  methods: {
    showModal(item) {
      this.$refs["shareModal"].show();
      this.toShare.reportUuid = item.uuid;
      this.toShare.originUserId = item.userId;
    },
    shareReportWithUserId() {
      console.log(this.toShare);
      fetch(
        process.env.VUE_APP_API_BASE_URL +
          "/api/v1/report/shareReportWithUserId",
        {
          method: "POST",
          body: JSON.stringify(this.toShare),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((json) => {
          this.message = json.message;
          this.toShare.shareToMail = "";
          this.getAllReports();
        });
    },
    getAllReports() {
      fetch(process.env.VUE_APP_API_BASE_URL + "/api/v1/report/getAllReports", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.localStorage.token}`,
        },
      })
        .then((response) => response.json())
        .then((json) => {
          this.reports = json;
        });
    },
    downloadReportsByUuid(report, type, extension) {
      this.isLoading = true;
      console.log(report);

      fetch(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/report/downloadReportsByUuid?uuid=${type}_${report.uuid}&extension=${extension}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`,
          },
        }
      )
        .then(async (res) => ({
          filename: type + "_" + report.uuid + extension,
          blob: await res.blob(),
        }))

        .then(async (blob) => {
          const binaryData = [];
          binaryData.push(blob.blob);
          const downloadUrl = window.URL.createObjectURL(new Blob(binaryData));

          const a = document.createElement("a");
          a.style.display = "none";

          if (typeof a.download === "undefined") {
            window.location.href = downloadUrl;
          } else {
            a.href = downloadUrl;
            a.download = type + "_" + report.uuid + extension;
            document.body.appendChild(a);
            a.click();
          }
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
    downloadCompleteReportsByUuid(report) {
      this.isLoading = true;
      console.log(report);

      fetch(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/report/downloadCompleteReportsByUuid?uuid=${report.uuid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`,
          },
        }
      )
        .then(async (res) => ({
          filename: report.uuid + ".docx",
          blob: await res.blob(),
        }))

        .then(async (blob) => {
          const binaryData = [];
          binaryData.push(blob.blob);
          const downloadUrl = window.URL.createObjectURL(new Blob(binaryData));

          const a = document.createElement("a");
          a.style.display = "none";

          if (typeof a.download === "undefined") {
            window.location.href = downloadUrl;
          } else {
            a.href = downloadUrl;
            a.download = report.uuid + ".docx";
            document.body.appendChild(a);
            a.click();
          }
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
    downloadJsonReportsByUuid(report) {
      fetch(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/report/downloadJsonReportsByUuid?uuid=${report.uuid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`,
          },
        }
      )
        .then(async (res) => ({
          filename: report.uuid + ".json",
          blob: await res.blob(),
        }))

        .then(async (blob) => {
          const binaryData = [];
          binaryData.push(blob.blob);
          const downloadUrl = window.URL.createObjectURL(new Blob(binaryData));

          const a = document.createElement("a");
          a.style.display = "none";

          if (typeof a.download === "undefined") {
            window.location.href = downloadUrl;
          } else {
            a.href = downloadUrl;
            a.download = report.uuid + ".json";
            document.body.appendChild(a);
            a.click();
          }
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
    confirmBeforeDelete(item) {
      if (
        window.confirm(
          "Attention, cette action est ***DEFINITIVE*** ! \nEtes-vous sûr de vouloir supprimer cet audit ?"
        )
      ) {
        this.hardDeleteReportByUserIdAndReportUuid(item);
      }
    },
    hardDeleteReportByUserIdAndReportUuid(item) {
      console.log(item);

      return fetch(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/report/hardDeleteReportByUserIdAndReportUuid`,
        {
          method: "POST",
          body: JSON.stringify({ userId: item.userId, reportUuid: item.uuid }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`,
          },
        }
      ).then(() => {
        this.getAllReports();
      });
      // .then((response) => response.json());
    },
  },
};
</script>
<style>
.absolute_center {
  position: absolute;
  top: 45%;
  left: 45%;
}
</style>
